// extracted by mini-css-extract-plugin
export default {"card":"vZ-z","carouselContainer":"wZ-z","carouselContent":"xZ-z"};